import {
  FEATURE_TOGGLE_VOLUME_BASED_PRICES,
  useFeatureToggleContext,
} from '../../../feature-toggles'
import { useProductPageContext } from '../productPageContext'

export const useShouldRenderVolumePricingLabel = (): boolean => {
  const { currentOffer } = useProductPageContext()
  const featureToggles = useFeatureToggleContext()
  if (!currentOffer) {
    return false
  }

  const isVolumePricingFeatureEnabled = Boolean(
    featureToggles[FEATURE_TOGGLE_VOLUME_BASED_PRICES],
  )
  const hasVolumePricing = Boolean(
    currentOffer.volumeBasedPrices && currentOffer.volumeBasedPrices.length > 1,
  )

  if (!isVolumePricingFeatureEnabled || !hasVolumePricing) {
    return false
  }

  return true
}
